var forms = {
  "formControl": {
    "WebkitAppearance": "none",
    "backgroundColor": "#f7f8f9",
    "border": "0.0625rem solid #c8c9c7",
    "borderRadius": "0.25rem",
    "color": "#333",
    "display": "block",
    "fontSize": "1rem",
    "lineHeight": "1.375rem",
    "minHeight": "3.125rem",
    "padding": "0 0.625rem",
    "transition": "border-color 0.25S ease-out",
    "width": "100%",
    "&::-ms-expand": {
      "backgroundColor": "transparent",
      "border": "0"
    },
    "&::-moz-placeholder": {
      "color": "#97999b"
    },
    "&:-ms-input-placeholder": {
      "color": "#97999b !important"
    },
    "&::placeholder": {
      "color": "#97999b"
    },
    "&::-ms-clear": {
      "display": "none",
      "width": "0",
      "height": "0"
    },
    "&:active:not(.disabled)": {
      "borderColor": "#006fcf",
      "outline": "none"
    },
    "&:focus:not(.disabled) .formControl:active:not(:disabled)": {
      "borderColor": "#006fcf",
      "outline": "none"
    },
    "&:focus:not(:disabled)": {
      "borderColor": "#006fcf",
      "outline": "none"
    },
    "&:disabled": {
      "backgroundColor": "#f7f8f9",
      "borderColor": "#c8c9c7 !important",
      "opacity": "1"
    },
    "&:invalid": {
      "boxShadow": "none"
    }
  },
  "formControl__disabled": {
    "backgroundColor": "#f7f8f9",
    "borderColor": "#c8c9c7 !important",
    "opacity": "1"
  },
  "formControlSuccess": {
    "backgroundPosition": "center right 0.78125rem",
    "backgroundRepeat": "no-repeat",
    "backgroundSize": "1.75rem",
    "paddingRight": "3.125rem",
    "backgroundImage": "url(\"https://www.aexp-static.com/cdaas/one/statics/@americanexpress/static-assets/2.25.0/package/dist/img/icons/status/dls-icon-success.svg\")"
  },
  "formControlWarning": {
    "backgroundPosition": "center right 0.78125rem",
    "backgroundRepeat": "no-repeat",
    "backgroundSize": "1.75rem",
    "paddingRight": "3.125rem",
    "borderColor": "#b42c01",
    "backgroundImage": "url(\"https://www.aexp-static.com/cdaas/one/statics/@americanexpress/static-assets/2.25.0/package/dist/img/icons/status/dls-icon-warning-filled.svg\")"
  },
  "hasWarning__formControl": {
    "borderColor": "#b42c01"
  },
  "textarea_formControl": {
    "fontSize": "0.9375rem",
    "padding": "0.9375rem 0.625rem"
  },
  "label": {
    "color": "#53565a"
  },
  "legend": {
    "marginBottom": "0.5rem",
    "fontSize": "0.875rem",
    "color": "#53565a"
  },
  "fieldset___input": {
    "&:not(:last-child)": {
      "marginBottom": "1.25rem"
    }
  },
  "alertForm": {
    "display": "block",
    "fontSize": "0.9375rem",
    "lineHeight": "1.375rem",
    "paddingTop": "0.3125rem",
    "color": "#b42c01"
  },
  "alertForm__icon": {
    "color": "#b42c01"
  },
  "btnForm": {
    "background": "transparent",
    "minWidth": "3rem",
    "padding": "0.625rem",
    "position": "absolute",
    "bottom": "0",
    "right": "0",
    "top": "0",
    "&:hover": {
      "background": "transparent"
    }
  },
  "inputgroup__hasWarning_label": {
    "color": "#b42c01"
  },
  "div_data_password_toggle_true__input_formControl": {
    "paddingRight": "3.75rem"
  }
};

export default forms;
